// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GJPqq","footer":"styles_footer__1z6Y6"};